import React, { useEffect, useState } from "react";
import { Wrapper } from "../components/Wrapper";
import { PageTitle } from "../components/PageTitle";
import { CustomTable } from "../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { Notification } from "../utils/Notification";
import { useMutation, useQuery } from "@apollo/client";
import { GET_FAQS } from "../graphql/Queries/FaqQuery";
import { DELETE_FAQ } from "../graphql/Mutations/FaqMutation";
import { getField } from "../utils/Helper";

export const Faq = ({ url }) => {
  const [items, setItems] = useState([]);
  const navigator = useNavigate();

  const { data } = useQuery(GET_FAQS, {
    fetchPolicy: "no-cache",
  });
  const [drop] = useMutation(DELETE_FAQ);

  useEffect(() => {
    if (data) {
      setItems(data.faq);
    }
  }, [data]);

  const remove = (id) => {
    drop({
      variables: {
        id: Number(id),
      },
    })
      .then((response) => {
        setItems(response.data.deleteFaq);
      })
      .catch((error) => {
        Notification(error);
      });
  };

  const edit = (id) => {
    navigator(`${url}/form?id=${id}`);
  };

  return (
    <Wrapper>
      <PageTitle title={"FAQ"} />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <CustomTable
                data={items}
                columns={[
                  { key: "id", label: "ID" },
                  {
                    key: `title`,
                    label: "Название",
                    callback: (item) => {
                      return getField(item, "value");
                    },
                  },
                  {
                    key: "tab",
                    label: "Группа",
                    callback: (item) => {
                      return getField(item.name, "value");
                    },
                  },
                  {
                    key: "status",
                    label: "Состояние",
                    callback: (item) => {
                      return Number(item) === 1 ? "Показывать" : "Скрыть";
                    },
                  },
                ]}
                search={true}
                sort={true}
                pagination={{
                  limit: 10,
                }}
                actions={[
                  {
                    slug: `${url}/form`,
                    icon: "fe-plus",
                    name: "Создать",
                  },
                ]}
                buttons={[
                  {
                    onClick: (row) => {
                      navigator(`${url}/faq-sort?id=${row.tab.id}`);
                    },
                    icon: "mdi mdi-sort",
                    title: "Сортировка",
                  },
                ]}
                onClick={(id) => edit(id)}
                onDelete={(id) => remove(id)}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
